import customAxios from './axios';
import CONFIG from '../../config';

export const getAll = () => {
    return customAxios.get(CONFIG.apiURL + '/TypingCenters').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getIndividual = (userID) => {
    return customAxios.get(CONFIG.apiURL + `/TypingCenters/${userID}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const create = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/TypingCenters/Create', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const update = (payload) => {
    return customAxios.put(CONFIG.apiURL + '/TypingCenters/Update', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllServices = () => {
    return customAxios.get(CONFIG.apiURL + '/Departments/Services').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getCspStaffs = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/TypingCenters/GetAllWithStaffs', payload).then(res => {
       return res['data'];
    });
};